import { render, staticRenderFns } from "./BclassName.vue?vue&type=template&id=8f883dc6&scoped=true&"
import script from "./BclassName.vue?vue&type=script&lang=js&"
export * from "./BclassName.vue?vue&type=script&lang=js&"
import style0 from "./BclassName.vue?vue&type=style&index=0&id=8f883dc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f883dc6",
  null
  
)

export default component.exports